import React from "react";
import { LoaderStyle } from "./loader.style";
import { Box, CircularProgress } from "@mui/material";

const Loader = ({ size = 60, absolute = false, color = "#545f71" }) => {
  return (
    <LoaderStyle size={size}>
      <Box
        className={`${absolute ? "absoluteLoader" : ""}`}
        data-testid="loading-box"
        aria-label="loading"
      >
        <CircularProgress size={size} sx={{ color: color }} />
      </Box>
    </LoaderStyle>
  );
};
export default Loader;
